import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
import ErrorHelper from "../Errors/ErrorHelper";
import I18n from "i18n-js";
import OwnerDetailBuilderWorkspace from "./OwnerDetailBuilderWorkspace";


class OwnerDetailBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: [],
      active_tab: 'general',
      tabs: [],
      address: this.props.owner_detail.address,
      first_name: this.props.owner_detail.first_name,
      last_name: this.props.owner_detail.last_name,
      email: this.props.owner_detail.email,
      phone: this.props.owner_detail.phone,
      room_owner_names: this.props.all_rooms_owner_names,
      rooms: this.props.rooms,
      all_rooms: this.props.all_rooms,
      date_format: this.props.date_format,
      time_format: this.props.time_format,
      owner_detail_notes_path: this.props.paths.owner_detail_notes_path,
      is_new: this.props.is_new,
      note_obj: this.props.note_obj,
      file_group: this.props.file_group_files,
      note_count: this.props.note_count,
      read_only: this.props.read_only,
      owner_detail_notes_data_table_path: this.props.paths.owner_detail_notes_data_table_path,
      all_rooms_room_types: this.props.all_rooms_room_types,
    };
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeRooms = this.onChangeRooms.bind(this)
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this)
    this.onChangeNote = this.onChangeNote.bind(this)
    this.onChangeFlagged = this.onChangeFlagged.bind(this)
    this.updateNoteCount = this.updateNoteCount.bind(this)
    this.onAddRoom = this.onAddRoom.bind(this)
    this.onRemoveRoom = this.onRemoveRoom.bind(this)
    this.onUpdateRoomWeeks = this.onUpdateRoomWeeks.bind(this)
    this.getRoomIndexById = this.getRoomIndexById.bind(this)
  }

 

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]

    return (
      <div className="FormFieldBuilder" ref="form">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons buttons={buttons} />
          <OwnerDetailBuilderWorkspace
            {...this.state} 
            onChange={this.onChange}
            onChangeRooms={this.onChangeRooms}
            onChangeFileUploadGroup={this.onChangeFileUploadGroup}
            onChangeNote={this.onChangeNote}
            onChangeFlagged={this.onChangeFlagged}
            updateNoteCount={this.updateNoteCount}
            buttons={buttons}
            onAddRoom={this.onAddRoom}
            onRemoveRoom={this.onRemoveRoom}
            onUpdateRoomWeeks={this.onUpdateRoomWeeks}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />  
      </div>
    );
  }

  tabs(){
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, ['first_name', 'last_name', 'email', 'phone', 'address','percentage_of_ownership']),
        },
        {
          tabName: I18n.t('room_ids'),
          targetName: 'rooms',
          classes: this.state.active_tab === 'rooms' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, ['rooms']),
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'owner-detail-notes',
          classes: this.state.active_tab === 'owner-detail-notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          labelCount: this.state.note_count,
          tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, ['notes']),
        },
      ]
    );
  };

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab});
  }

  onChange(name, event) {
    this.state[name] =
      event && event.target && typeof event.target.value !== "undefined"
        ? event.target.value
        : event;
    this.forceUpdate(() => {
      if (typeof this.props.onChange == "function") {
        this.props.onChange(this.state);
      }
    });
  }

  onChangeRooms(selected_rooms) {
    this.setState({ rooms: selected_rooms });
  }

  onAddRoom(room) {
    var rooms = this.state.rooms.slice(0);
    rooms.unshift(room);
    this.setState({ rooms });
  }

  onRemoveRoom(roomId) {
    var rooms = this.state.rooms.slice(0);
    var idx = this.getRoomIndexById(roomId);
    if (idx >= 0) {
      rooms.splice(idx, 1);
      this.setState({ rooms });
    }
  }

  getRoomIndexById(id) {
    for (var i = 0, ilen = this.state.rooms.length; i < ilen; i++) {
      if (this.state.rooms[i].id == id) {
        return i;
      }
    }
  }

  onChangeFileUploadGroup(file_group) {
    this.setState({file_group: file_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }

  onChangeFlagged(input) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = input.target.checked
    this.setState({note_obj: note_obj});
  }

  updateNoteCount(count) {
    this.setState({note_count: count})
  }

  onSubmit() {
    var self = this
    self.setState({ loading: true})
    setTimeout(function () {
      $.ajax({
        type: self.props.is_new ? 'POST' : 'PATCH',
        url: self.props.is_new
        ? self.props.paths.owner_detail_create_path
        : self.props.paths.owner_detail_update_path,
        data: {
            owner_detail : {
                address: self.state.address,
                first_name: self.state.first_name,
                last_name: self.state.last_name,
                phone: self.state.phone,
                email: self.state.email,
                updated_at: self.state.updated_at,
                percentage_of_ownership: self.state.percentage_of_ownership,
            },
            note: self.state.note_obj || null,
            file_group_files: self.state.file_group && self.state.file_group.file_uploads ? self.state.file_group.file_uploads.map(file => file.id) : null,         
            rooms: self.state.rooms,
        } 
      }).done(function (data) {
        if(data && data.errors) {
          self.setState({
            errors: data.errors,
            loading: false
          })
        } else {
          if (parent && parent.refresh_data) {
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t('owner_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('owner_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
        }  
      }).catch((data) => {
        if (data && data.responseJSON) {
          self.setState({errors: data.responseJSON.errors || data.responseJSON, loading: false})
          $('.modal-body').scrollTop(0)
        }
      })
    }, 1000)
  };

  onUpdateRoomWeeks(roomId, weeks) {
    const rooms = this.state.rooms.map(room => {
      if (room.id === roomId) {
        return { ...room, weeks_owned: weeks };
      }
      return room;
    });
    this.setState({ rooms });
  }
}
export default OwnerDetailBuilder;